module.exports = __webpack_public_path__ + "img/aiqiyisp.24c77f0b.jpg";